<template>
  <div id="app" class="app-content mb-4">
    <app-header></app-header>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <b-card-group deck>
            <HelpMenu></HelpMenu>
            <ContactDetail></ContactDetail>
            <MainBalance></MainBalance>
          </b-card-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "../reuseable_components/Header.vue";
import HelpMenu from "./HelpMenu.vue";
import ContactDetail from "./ContactDetail.vue";
import MainBalance from "./MainBalance.vue";

export default {
  name: "Help",
  components: {
    "app-header": AppHeader,
    HelpMenu: HelpMenu,
    ContactDetail: ContactDetail,
    MainBalance: MainBalance,
  },
};
</script>

<style lang="scss" scoped>
</style>
